import React from "react";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { NavLink } from "react-router-dom";

import { spacing } from "@mui/system";
import { green } from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";

import {
  Box as MuiBox,
  Chip,
  Drawer as MuiDrawer,
  ListItemButton,
  CircularProgress,
} from "@mui/material";

// import { ReactComponent as Logo } from "../../vendor/logo.svg";
import Logo from "../../vendor/hyper_radius_logo.png";
import STLogo from "../../vendor/st_logo.png";
import Footer from "./SidebarFooter";
import SidebarNav from "./SidebarNav";

const Box = styled(MuiBox)(spacing);

const Drawer = styled(MuiDrawer)`
  border-right: 1px solid rgba(0, 0, 0, 0.12);

  > div {
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
  }
`;

const shimmer = keyframes`
  0% { left: -150%; }
  100% { left: 250%; }
`;

const breathe = keyframes`
  0%, 100% { transform: scale(1); box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15); }
  50% { transform: scale(1.05); box-shadow: 0 8px 24px rgba(59, 130, 246, 0.3); }
`;

const Brand = styled(ListItemButton)`
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: 800;
  color: #1e40af;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  font-family: ${(props) => props.theme.typography.fontFamily};
  min-height: 74px;
  padding-left: ${(props) => props.theme.spacing(4)};
  padding-right: ${(props) => props.theme.spacing(4)};
  justify-content: flex-start;
  cursor: pointer;
  flex-grow: 0;
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  z-index: 10;
  transition: all 0.4s ease;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: -150%;
    width: 60%;
    height: 100%;
    background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.9), transparent);
    transform: skewX(-25deg);
    animation: ${shimmer} 4s infinite linear;
  }

  &:hover {
    background: #fff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  }

  & .MuiBox-root {
    letter-spacing: 1.5px;
    color: #1e293b;
    font-weight: 900;
  }
`;

// const BrandIcon = styled(Logo)`
//   margin-right: ${(props) => props.theme.spacing(2)};
//   color: ${(props) => props.theme.sidebar.header.brand.color};
//   fill: ${(props) => props.theme.sidebar.header.brand.color};
//   width: 32px;
//   height: 32px;
// `;

const BrandLogo = styled("img")`
  border-radius: 50%;
  border: 2px solid #3b82f6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  animation: ${breathe} 3s infinite ease-in-out;

  &:hover {
    transform: scale(1.1) translateY(-2px);
    box-shadow: 0 8px 24px rgba(59, 130, 246, 0.25);
    animation-play-state: paused;
  }
`;

const Sidebar = ({ items, showFooter = true, logoSrc, logoTextName, collapsed, ...rest }) => {
  const theme = useTheme();
  return (
    <Drawer variant="permanent" {...rest}>
      <Brand component={NavLink} to="/" theme={theme}>
        {logoSrc ? (
          <BrandLogo src={logoSrc} alt="Hyper Radius Logo" width={46} height={46} />
        ) : (
          <CircularProgress size={30} color="primary" />
        )}

        {!collapsed && (
          <Box
            ml={3}
            sx={{
              fontWeight: 700,
              whiteSpace: "nowrap",
              textTransform: "uppercase",
              letterSpacing: "1px",
              fontSize: "0.9rem",
              background: "linear-gradient(to right, #1e3a8a, #3b82f6)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {logoTextName}
          </Box>
        )}
      </Brand>
      <SidebarNav items={items} collapsed={collapsed} />
      {/* {!!showFooter && <Footer />} */}
    </Drawer>
  );
};

export default Sidebar;
